module.exports = {
  INVALID: 'INVALIDO',
  PAID: 'PAGO',
  UNPAYABLE: 'IMPAGAVEL',
  NOT_FOUND: 'NAO_ENCONTRADO',
  NOT_REGISTERED: 'NAO_REGISTRADO',
  UNPAID: 'NAO_PAGO'
};
